import type { ButtonClickContext, TabViewContext } from '@orus.eu/pharaoh'
import { isSuccess } from '@orus.eu/result'

import { router } from '../../router.tsx'

import { getPageNameAndResourceIdFromRoute } from './page-identification.ts'
import { createTrackingMessage, sendMessage } from './tracking.ts'

export function sendButtonClickMessage(context: ButtonClickContext): void {
  const matches = router.matchRoutes(window.location.pathname, window.location.search)
  const match = matches.at(-1)
  if (!match) return
  const resourceAndPath = getPageNameAndResourceIdFromRoute({ routeId: match.routeId, params: match.params })

  if (context.buttonName === 'contact_button') {
    sendMessage(
      createTrackingMessage({
        event: 'contact_advisor_clicked',
      }),
    )
    return
  }

  if (context.buttonIcon === 'whatsapp-brands') {
    sendMessage(
      createTrackingMessage({
        event: 'whatsapp_conversation_button_clicked',
      }),
    )
    return
  }

  if (context.buttonName === 'call_button') {
    sendMessage(
      createTrackingMessage({
        event: 'phone_number_button_clicked',
        phone_number: context.buttonText ?? null,
      }),
    )
    return
  }

  sendMessage(
    createTrackingMessage({
      event: 'click_button',
      button_name: context.buttonName ?? null,
      button_icon: context.buttonIcon ?? null,
      button_text: context.buttonText ?? null,
      page_name: isSuccess(resourceAndPath) ? resourceAndPath.output.pageName : null,
      page_resource_id: isSuccess(resourceAndPath) ? resourceAndPath.output.resourceId : null,
    }),
  )
}

export function sendTabViewMessage({ tabId }: TabViewContext): void {
  sendMessage(createTrackingMessage({ event: 'tab_viewed', tab_id: tabId }))
}
